<template>
  <q-section v-bind="$attrs">
    <q-section :bg-i="props.user1.avatar_url" :key="props.user1.avatar_url" pl="0" :wh="userSize" bdr="50%"
      @click="handleAvatarClick(props.user1.user_id)">
    </q-section>
    <q-section :bg-i="props.user2.avatar_url" :key="props.user2.avatar_url" pr="0" :wh="userSize" bdr="50%" pz="5"
      @click="handleAvatarClick(props.user2.user_id)"></q-section>
    <slot></slot>
  </q-section>
</template>

<script setup lang="ts">
const props = defineProps({
  user1: {
    type: Object,
    default: () => ({}),
  },
  user2: {
    type: Object,
    default: () => ({}),
  },

  userSize: {
    type: [String, Number],
    default: 33,
  },
})

const emit = defineEmits<{
  (e: 'avatarClick', userId: number): void
}>()

const handleAvatarClick = (userId: number) => {
  emit('avatarClick', userId)
}
</script>

<style scoped lang="scss"></style>
